import styled from 'styled-components';
import colors from '@theme/colors';

export const FieldOption = styled.option`
  font-family: GTAmerica;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${({ dark }) => (dark ? colors['charcoal'] : colors['charcoal'])};
`;
